/* 🟢 KCS HOOD PDP SCRIPT [2026-10-17] */
/* Runs sections/kcs_hood-pdp.liquid (templates product.range-hood and product.wood-hood).
   Reads only #kcs-hood-data (store data written by the section). No product facts or prices are hard-coded here.
   Hood Finder rules: assets/kcs_hood-finder-core.js (global HF), shared with every hood page.
   Wood hoods: size + finish pick the variant; options_json add-ons are separate hidden products added to the cart
   in the same /cart/add.js call, each tagged _For = the hood line and _kcs_group = a token shared with the hood line. */
(function () {
  var root = document.getElementById('kcs-hood');
  var dataEl = document.getElementById('kcs-hood-data');
  if (!root || !dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var $ = function (id) { return document.getElementById(id); };
  var qa = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
  var WOOD = D.mode === 'wood', HD = D.hood || {}, WD = D.wood || {};

  /* ---------- helpers ---------- */
  function money(cents) {
    var n = (cents || 0) / 100, fmt = D.moneyFormat || '${{amount}}';
    var s2 = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var s0 = Math.round(n).toLocaleString('en-US');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) { return k === 'amount_no_decimals' ? s0 : s2; });
  }
  function frac(x) {
    if (x === null || x === undefined || isNaN(x)) return '';
    var n16 = Math.round(x * 16), w = Math.floor(n16 / 16), r = n16 % 16, d = 16;
    while (r && r % 2 === 0) { r /= 2; d /= 2; }
    return r ? (w ? w + '-' : '') + r + '/' + d : '' + w;
  }
  function esc(s) { return String(s === null || s === undefined ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function num(id) { var el = $(id); if (!el) return null; var v = parseFloat((el.value || '').replace(/[^\d.]/g, '')); return isNaN(v) ? null : v; }
  function dollarsToCents(x) { return Math.round((+x || 0) * 100); }
  function parseIn(t) { var m = String(t || '').match(/(\d+)(?:-(\d+)\/(\d+))?|(\d+)\/(\d+)/); if (!m) return null; if (m[4]) return +m[4] / +m[5]; return +m[1] + (m[2] ? +m[2] / +m[3] : 0); }
  function depthName(c) { return String(c.label || '').replace(/\s*inside depth.*$/i, '').replace(/^Increase interior depth to\s*/i, ''); }
  function aid(c) { return c ? (c.addon_variant_id || c.variant_id || null) : null; }

  /* ---------- gallery: the rail matches the main photo's height and fits exactly 4 thumbs; the rest scroll ---------- */
  var rail = $('kcs-q-rail'), strip = $('kcs-q-strip'), dimg = $('kcs-q-dimg'), dmain = root.querySelector('.q-dmain'), GAP = 16;
  function edges() { if (!rail) return; rail.classList.toggle('more-above', rail.scrollTop > 2); rail.classList.toggle('more-below', rail.scrollTop + rail.clientHeight < rail.scrollHeight - 2); }
  function fitRail() {
    if (!rail || !dmain) return;
    var H = dmain.offsetHeight; if (!H) return;
    rail.style.height = H + 'px';
    var h = (H - GAP * 3) / 4;
    qa('.q-thumb', rail).forEach(function (t) { t.style.height = h + 'px'; });
    edges();
  }
  function showMedia(id, src, alt) {
    var btn = rail && rail.querySelector('.q-thumb[data-media="' + id + '"]');
    if (btn) { src = src || btn.dataset.src; alt = alt || btn.dataset.alt; }
    if (dimg && src) {
      dimg.classList.add('swap');
      setTimeout(function () { dimg.src = src; if (alt) dimg.alt = alt; dimg.classList.remove('swap'); }, 120);
    }
    if (rail) {
      qa('.q-thumb', rail).forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
      if (btn && (btn.offsetTop - rail.offsetTop < rail.scrollTop || btn.offsetTop - rail.offsetTop + btn.offsetHeight > rail.scrollTop + rail.clientHeight)) rail.scrollTo({ top: btn.offsetTop - rail.offsetTop - 8, behavior: 'smooth' });
    }
    var sl = strip && strip.querySelector('.q-slide[data-media="' + id + '"]');
    if (sl && strip.offsetParent) strip.scrollTo({ left: sl.offsetLeft, behavior: 'smooth' });
  }
  if (rail) {
    qa('.q-thumb', rail).forEach(function (b) { b.addEventListener('click', function () { showMedia(b.dataset.media); }); });
    rail.addEventListener('scroll', edges, { passive: true });
    if ('ResizeObserver' in window && dmain) new ResizeObserver(fitRail).observe(dmain); else window.addEventListener('resize', fitRail);
    if (dimg && !dimg.complete) dimg.addEventListener('load', fitRail);
    fitRail();
  }
  qa('[data-jump]').forEach(function (b) { b.addEventListener('click', function () { var t = document.querySelector(b.dataset.jump); if (t) t.scrollIntoView({ behavior: 'smooth' }); }); });

  /* ---------- variants (Liquid lists up to 250; the rest come from the kcs-hood-variant view) ---------- */
  var VAR = {}, VBYID = {};
  function vkey(opts) { return opts.join('\u0001'); }
  function addVariant(v) { if (!v) return; VAR[vkey(v.opts)] = v; VBYID[v.id] = v; }
  (D.variants || []).forEach(addVariant);
  var pending = {};
  function getVariant(opts) {
    var k = vkey(opts);
    if (VAR[k]) return Promise.resolve(VAR[k]);
    if (VAR[k] === null) return Promise.resolve(null);
    if ((D.variants || []).length >= (D.variantsCount || 0)) return Promise.resolve(null);
    if (pending[k]) return pending[k];
    var ids = opts.map(function (val, i) { var o = D.options[i], m = o && o.values.filter(function (x) { return x.v === val; })[0]; return m ? m.id : null; });
    if (ids.indexOf(null) > -1) return Promise.resolve(null);
    var url = D.url + (D.url.indexOf('?') > -1 ? '&' : '?') + 'view=kcs-hood-variant&option_values=' + ids.join(',');
    pending[k] = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      if (j.inserts) Object.keys(j.inserts).forEach(function (id) { D.inserts[id] = j.inserts[id]; });
      var v = j.variant && vkey(j.variant.opts) === k ? j.variant : null;
      if (v) addVariant(v); else VAR[k] = null;
      return v;
    }).catch(function () { return null; });
    return pending[k];
  }
  function cached(opts) { return VAR[vkey(opts)] || null; }

  /* ---------- price block ---------- */
  function priceHtml(now, was) {
    if (was > now) return '<span class="was">List price <s>' + money(was) + '</s></span><span class="now">Marked down to ' + money(now) + '</span><span class="save">You save ' + money(was - now) + '</span>';
    return '<span class="now">' + money(now) + '</span>';
  }
  var priceEl = $('kcs-price'), priceFor = $('kcs-price-for'), atc = $('kcs-q-atc'), vid = $('kcs-variant-id'), form = $('kcs-hood-form');
  var info = $('kcs-q-info'), ibox = $('kcs-q-info-box'), msg = $('kcs-atc-msg');
  function setUrl(v) { try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {} }

  /* =====================================================================
     VENTILATED (Victory hoods, inserts, parts): one button row per option
     ===================================================================== */
  if (!WOOD) {
    var sel = [];
    var curV = D.picked ? VBYID[D.cur] : null;
    if (curV) sel = curV.opts.slice();
    var rows = qa('.q-vopt');
    function applyVent() {
      rows.forEach(function (row) {
        var p = +row.dataset.pos;
        qa('.q-opt', row).forEach(function (b) { b.setAttribute('aria-pressed', sel[p] === b.dataset.val ? 'true' : 'false'); });
      });
      var complete = rows.length && rows.every(function (r) { return sel[+r.dataset.pos] !== undefined; });
      if (!complete) return;
      var v = cached(sel);
      qa('.tbl-opts tbody tr').forEach(function (r) { r.classList.toggle('is-current', v && r.dataset.variant == v.id); });
      if (!v) { atc.disabled = true; atc.textContent = 'Not available'; return; }
      vid.value = v.id;
      priceEl.innerHTML = priceHtml(v.price, v.compare);
      priceFor.textContent = v.title + ' selected';
      atc.disabled = !v.available; atc.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.txt && info) { info.textContent = v.title + ' · ' + v.txt; ibox.hidden = false; }
      if (v.media) showMedia(v.media, v.img, v.alt);
      setUrl(v);
    }
    rows.forEach(function (row) {
      qa('.q-opt', row).forEach(function (b) { b.addEventListener('click', function () { sel[+row.dataset.pos] = b.dataset.val; applyVent(); }); });
    });
    if (form) form.addEventListener('submit', function (e) { if (atc.disabled) e.preventDefault(); });
  }

  /* =====================================================================
     WOOD HOODS: style links, size, finish, add-on options, live total
     ===================================================================== */
  var S = null, SIZES = [], FINS = [], OPTS = [], sizePos = -1, finPos = -1;
  if (WOOD) {
    D.options.forEach(function (o, i) { var n = o.name.toLowerCase(); if (n.indexOf('size') > -1) sizePos = i; else if (n.indexOf('finish') > -1 || n.indexOf('color') > -1) finPos = i; });
    var cv = VBYID[D.cur] || D.variants[0];
    // sizes: width x height from the variant metafields, else the first two numbers in the Size value
    if (sizePos > -1) D.options[sizePos].values.forEach(function (x) {
      var w = null, h = null;
      (D.variants || []).some(function (v) { if (v.opts[sizePos] === x.v && v.w) { w = +v.w; h = +v.h; return true; } });
      if (!w) { var m = x.v.match(/\d+(?:\.\d+)?/g) || []; w = m[0] ? +m[0] : null; h = m[1] ? +m[1] : null; }
      SIZES.push({ v: x.v, w: w, h: h });
    });
    if (finPos > -1) FINS = D.options[finPos].values.map(function (x) { return x.v; });
    OPTS = (Array.isArray(WD.options) ? WD.options : []).filter(function (o) { return o && o.choices && o.choices.length; });
    if (Array.isArray(WD.paint) && WD.paint.length && !OPTS.some(function (o) { return o.key === 'paint'; }))
      OPTS.push({ key: 'paint', label: 'Custom paint match', choices: [{ v: '', label: 'No paint match' }].concat(WD.paint) });
    OPTS.forEach(function (o) {
      o.choices.forEach(function (c, i) {
        // derived flags; the data may also set them directly
        if (c.custom === undefined) c.custom = i > 0 && (o.key === 'depth' || o.key === 'cut');
        if (c.rush === undefined) c.rush = i > 0 && o.key === 'rush';
        if (c.needs_code === undefined) c.needs_code = o.key === 'paint' && /code/i.test(String(c.v) + ' ' + c.label);
        if (o.key === 'trim' && c.add_in === undefined) { var m = String(c.label).match(/adds?\s+([\d\-\/]+)"/i); if (m) c.add_in = parseIn(m[1]); }
      });
    });
    S = { size: cv ? cv.opts[sizePos] : null, fin: cv && finPos > -1 ? cv.opts[finPos] : null, opt: {}, code: '' };
    OPTS.forEach(function (o) { if (o.choices && o.choices.length) S.opt[o.key] = String(o.choices[0].v); });
  }
  function sizeObj(v) { return SIZES.filter(function (s) { return s.v === (v || S.size); })[0] || {}; }
  function sizeFor(w, h) { return SIZES.filter(function (s) { return s.w === w && s.h === h; })[0]; }
  function optsFor(size, fin) { var o = (D.options || []).map(function () { return null; }); if (sizePos > -1) o[sizePos] = size; if (finPos > -1) o[finPos] = fin; return o; }
  function curOpts() { return optsFor(S.size, S.fin); }
  function choice(key) {
    var o = OPTS.filter(function (x) { return x.key === key; })[0]; if (!o) return null;
    return o.choices.filter(function (c) { return String(c.v) === S.opt[key]; })[0] || o.choices[0];
  }
  function addonPrice(c) {
    if (!c || !aid(c)) return { now: 0, was: 0, ok: true };
    var a = (WD.addons || {})[aid(c)];
    if (a) return { now: a.price, was: a.compare > a.price ? a.compare : a.price, ok: a.available !== false };
    var now = dollarsToCents(c.ours), was = dollarsToCents(c.list);
    return { now: now, was: was > now ? was : now, ok: true };
  }
  function openingFor(v) { var so = sizeObj(); if (!so.w) return null; var o = WD.openings && WD.openings[String(so.w)]; if (o) return +o; if (v && v.open) return +v.open; return WD.deduct ? so.w - WD.deduct : null; }
  function interiorDepth() { var c = choice('depth'); return c && c.depth ? +c.depth : (WD.depth ? +WD.depth : null); }
  function heightsList() { var hs = []; SIZES.forEach(function (s) { if (s.h && hs.indexOf(s.h) < 0) hs.push(s.h); }); return hs.sort(function (a, b) { return a - b; }); }
  function widthsList() { var ws = []; SIZES.forEach(function (s) { if (s.w && ws.indexOf(s.w) < 0) ws.push(s.w); }); return ws.sort(function (a, b) { return a - b; }); }

  function buildSizeButtons() {
    var wr = $('kcs-w-row'), hr = $('kcs-h-row'); if (!wr || !hr) return;
    var so = sizeObj();
    wr.innerHTML = widthsList().map(function (w) { return '<button type="button" class="q-opt q-w" data-w="' + w + '" aria-pressed="' + (w === so.w) + '"><b>' + w + '"</b><small>wide</small></button>'; }).join('');
    hr.innerHTML = heightsList().map(function (h) {
      var ok = !!sizeFor(so.w, h);
      return '<button type="button" class="q-opt q-h" data-h="' + h + '" aria-pressed="' + (h === so.h) + '"' + (ok ? '' : ' disabled') + '><b>' + h + '"</b><small>' + (ok ? 'tall' : 'not in this width') + '</small></button>';
    }).join('');
    qa('.q-w', wr).forEach(function (b) { b.addEventListener('click', function () { setSize(+b.dataset.w, sizeObj().h); }); });
    qa('.q-h', hr).forEach(function (b) { b.addEventListener('click', function () { setSize(sizeObj().w, +b.dataset.h); }); });
  }
  function setSize(w, h) {
    var s = sizeFor(w, h);
    if (!s) { var alt = SIZES.filter(function (x) { return x.w === w; }); s = alt.filter(function (x) { return x.h === h; })[0] || alt[0]; }
    if (!s) return;
    S.size = s.v; update(false);
  }
  function finGroup(name) {
    var f = (Array.isArray(WD.finishes) ? WD.finishes : []).filter(function (x) { return (x.label || x.name) === name; })[0];
    return f && f.group ? f.group : '';
  }
  function buildFinishes() {
    var box = $('kcs-fin-groups'); if (!box || finPos < 0) return;
    var groups = [], by = {};
    FINS.forEach(function (f) { var g = finGroup(f); if (!by[g]) { by[g] = []; groups.push(g); } by[g].push(f); });
    var base = cached(optsFor(S.size, FINS[0]));
    box.innerHTML = groups.map(function (g) {
      return (g ? '<p class="fin-grp">' + esc(g) + '</p>' : '') + '<div class="sw-grid" role="group" aria-label="' + esc(g || 'Finish') + '">' + by[g].map(function (f) {
        var v = cached(optsFor(S.size, f)), img = v && v.img;
        if (!img) (D.variants || []).some(function (x) { if (x.opts[finPos] === f && x.img) { img = x.img; return true; } });
        var p = '';
        if (v && base) p = v.price > base.price ? '+' + money(v.price - base.price) : 'Included';
        return '<button type="button" class="sw" data-f="' + esc(f) + '" aria-pressed="' + (f === S.fin) + '"' + (v && !v.available ? ' disabled' : '') + '>' +
          (img ? '<img src="' + esc(img.replace(/width=\d+/, 'width=200')) + '" alt="" loading="lazy">' : '<span class="nophoto">Photo coming</span>') +
          '<span class="sw-n">' + esc(f) + '</span>' + (p ? '<span class="sw-p">' + p + '</span>' : '') + '</button>';
      }).join('') + '</div>';
    }).join('');
    qa('.sw', box).forEach(function (b) { b.addEventListener('click', function () { S.fin = b.dataset.f; update(true); }); });
  }
  function optLabel(c) { var p = addonPrice(c); return c.label + (p.now ? ' (+' + money(p.now) + ')' : ''); }
  function buildOptions() {
    var box = $('kcs-q-opts'), pbox = $('kcs-paint');
    if (box) box.innerHTML = OPTS.filter(function (o) { return o.key !== 'paint'; }).map(function (o) {
      if (o.fixed || o.choices.length === 1) return '<label>' + esc(o.label) + '<span class="fin" style="display:flex;align-items:center;min-height:48px">' + esc(o.choices[0].label) + '</span></label>';
      return '<label for="kcs-o-' + esc(o.key) + '">' + esc(o.label) + '<select class="fin" id="kcs-o-' + esc(o.key) + '" data-k="' + esc(o.key) + '">' + o.choices.map(function (c) {
        return '<option value="' + esc(c.v) + '"' + (String(c.v) === S.opt[o.key] ? ' selected' : '') + '>' + esc(optLabel(c)) + '</option>';
      }).join('') + '</select></label>';
    }).join('');
    qa('#kcs-q-opts select').forEach(function (s) { s.addEventListener('change', function () { S.opt[s.dataset.k] = s.value; update(false); }); });
    var po = OPTS.filter(function (o) { return o.key === 'paint'; })[0];
    if (pbox && po) {
      var pc = choice('paint');
      pbox.innerHTML = '<details class="pm"' + (aid(pc) ? ' open' : '') + '><summary>' + esc(po.label) + '</summary><div class="pm-body">' + po.choices.map(function (c) {
        var p = addonPrice(c);
        return '<label class="pm-opt"><input type="radio" name="kcs-pm" value="' + esc(c.v) + '"' + (String(c.v) === S.opt.paint ? ' checked' : '') + '><span>' + esc(c.label) + (p.now ? ' <b>+' + money(p.now) + '</b>' + (p.was > p.now ? ' <s>' + money(p.was) + '</s>' : '') : '') + '</span></label>';
      }).join('') + '<label class="dfield" id="kcs-pm-code-l"' + (pc && pc.needs_code ? '' : ' hidden') + '><span>Paint color code (Sherwin-Williams or Benjamin Moore)</span><input class="fin" id="kcs-pm-code" type="text" autocomplete="off" value="' + esc(S.code) + '" placeholder="e.g. SW 7005"></label></div></details>';
      qa('input[name=kcs-pm]', pbox).forEach(function (r) { r.addEventListener('change', function () {
        S.opt.paint = r.value;
        var c = choice('paint');
        if (aid(c)) { var primed = FINS.filter(function (f) { return /prime|paint ready/i.test(f); })[0]; if (primed) S.fin = primed; }
        $('kcs-pm-code-l').hidden = !(c && c.needs_code);
        update(true);
      }); });
      var codeIn = $('kcs-pm-code'); if (codeIn) codeIn.addEventListener('input', function () { S.code = codeIn.value.trim(); });
    }
  }
  function optRows() {
    var t = $('kcs-opt-rows'); if (!t) return;
    var o = [];
    OPTS.forEach(function (x) { x.choices.forEach(function (c) { var p = addonPrice(c); if (p.now) o.push('<tr><th scope="row">' + esc(x.label) + ': ' + esc(c.label) + '</th><td>' + (p.was > p.now ? '<span class="was-sm"><s>' + money(p.was) + '</s></span> ' : '') + '<b>+' + money(p.now) + '</b></td></tr>'); }); });
    t.innerHTML = o.join('');
  }
  function sizeRows() {
    var fl = $('kcs-size-fin'); if (fl) fl.textContent = S.fin || '';
    var tl = $('kcs-ow-trim'), tcc = choice('trim'); if (tl && tcc) tl.textContent = 'with ' + tcc.label.replace(/\s*\(.*\)$/, '').toLowerCase();
    qa('#kcs-size-rows tr').forEach(function (tr) {
      var sv = tr.dataset.size; tr.classList.toggle('is-current', sv === S.size);
      var owc = tr.querySelector('[data-ow]'), tw = sizeObj(sv).w, tc = choice('trim');
      if (owc && tw && tc && tc.add_in !== undefined) owc.textContent = frac(tw + +tc.add_in) + '"';
      getVariant(optsFor(sv, S.fin)).then(function (v) {
        var cells = tr.children, last = cells[cells.length - 1], pn = cells[cells.length - 2];
        if (!v) { last.innerHTML = '<span class="note">Not made in ' + esc(S.fin) + '</span>'; pn.textContent = ''; return; }
        pn.textContent = v.sku || '';
        last.innerHTML = (v.compare > v.price ? '<span class="was-sm"><s>' + money(v.compare) + '</s></span> ' : '') + '<b>' + money(v.price) + '</b>';
      });
    });
  }
  function total(v) {
    var now = v.price, was = v.compare > v.price ? v.compare : v.price, ok = v.available;
    OPTS.forEach(function (o) { var p = addonPrice(choice(o.key)); now += p.now; was += p.was; ok = ok && p.ok; });
    return { now: now, was: was, ok: ok };
  }
  var curWood = null, seq = 0;
  function update(photo) {
    var my = ++seq;
    getVariant(curOpts()).then(function (v) {
      if (my !== seq) return;
      curWood = v;
      buildSizeButtons(); buildFinishes(); buildOptions(); sizeRows(); optRows();
      var fn = $('kcs-fin-now'); if (fn) fn.textContent = aid(choice('paint')) ? 'Custom paint match' : (S.fin || '');
      if (!v) {
        priceEl.innerHTML = '<span class="now">Not available</span>';
        priceFor.textContent = S.size + (S.fin ? ', ' + S.fin : '') + ' is not made. Pick another size or finish.';
        atc.disabled = true; atc.textContent = 'Not available';
        keys(null); inserts(); finder();
        return;
      }
      vid.value = v.id;
      var t = total(v);
      priceEl.innerHTML = priceHtml(t.now, t.was);
      priceFor.textContent = v.title + (v.sku ? ' · ' + v.sku : '');
      atc.disabled = !t.ok; atc.textContent = t.ok ? 'Add to cart' : 'Sold out';
      keys(v); inserts(); finder();
      if (photo && v.media) showMedia(v.media, v.img, v.alt);
      setUrl(v);
    });
  }
  function keys(v) {
    var so = sizeObj(), set = function (id, t) { var el = $(id); if (el) el.textContent = t; };
    var tr = choice('trim'), add = null;
    if (WD.trimmed) {
      if (tr && tr.add_in !== undefined) add = +tr.add_in;
      else if (WD.trimAdd) add = WD.trimAdd[tr ? tr.v : 'classic'] !== undefined ? +WD.trimAdd[tr ? tr.v : 'classic'] : (WD.trimAdd.classic !== undefined ? +WD.trimAdd.classic : null);
    }
    if (so.w) set('kcs-k-ow', add !== null ? frac(so.w + add) + '"' + (tr ? ' with ' + tr.label.replace(/\s*\(.*\)$/, '').toLowerCase() : '') : so.w + '"');
    var cut = choice('cut'), ext = choice('ext'), hh = so.h ? so.h - (cut && cut.cut ? +cut.cut : 0) + (ext && ext.ext ? +ext.ext : 0) : null;
    if (hh !== null) set('kcs-k-h', hh + '"' + (hh !== so.h ? ' (from ' + so.h + '")' : ''));
    var open = openingFor(v), dep = interiorDepth();
    set('kcs-k-open', open ? frac(open) + '" wide' + (dep ? ' x ' + frac(dep) + '" deep' : '') : '');
    var hint = $('kcs-size-hint'); if (hint) hint.textContent = open ? 'Inside opening for your insert: ' + frac(open) + '" wide' + (dep ? ', ' + frac(dep) + '" deep' : '') + (WD.apronH ? ', ' + frac(WD.apronH) + '" apron' : '') + '.' : '';
    var custom = OPTS.some(function (o) { var c = choice(o.key); return c && c.custom; });
    var ch = $('kcs-custom-hint'); if (ch) ch.hidden = !custom;
    var bl = $('kcs-build-line'), rush = OPTS.some(function (o) { var c = choice(o.key); return c && c.rush && aid(c); }), paint = choice('paint');
    var txt = rush && WD.rushBuild ? 'Rush build: ' + WD.rushBuild + '.' : (aid(paint) && WD.paintBuild ? 'Paint-matched hoods: ' + WD.paintBuild + ' to build.' : (WD.build ? 'Built in ' + WD.build + '.' : ''));
    if (bl) { bl.textContent = txt; bl.hidden = !txt; }
  }

  /* ---------- What goes inside (wood): inserts that fit the chosen size, from variant kcs_wood_hood.fit_inserts ---------- */
  var FD = { where: 'wall', fuel: null, vent: null, pwr: null };
  function cfmNeed() {
    var cook = num('kcs-f-cook'); if (!cook || typeof HF === 'undefined') return null;
    var btu = parseInt((($('kcs-f-btu') || {}).value || '').replace(/\D/g, ''), 10) || 0;
    return HF.cfm(cook, FD.fuel || 'unsure', btu, FD.where === 'island');
  }
  function fitList() {
    var v = curWood, so = sizeObj(); if (!so.w) return [];
    var open = openingFor(v), dep = interiorDepth(), c = cfmNeed();
    var rows = WD.fits && WD.fits[String(so.w)];
    if (!Array.isArray(rows)) return [];
    var depthOpt = (OPTS.filter(function (o) { return o.key === 'depth'; })[0] || { choices: [] }).choices;
    return rows.map(function (f) {
      var i = D.inserts[f.handle]; if (!i) return null;
      var gap = f.side_gap_in !== undefined && f.side_gap_in !== null ? +f.side_gap_in : (open && i.w ? Math.round((open - i.w) / 2 * 1000) / 1000 : null);
      var need = f.depth_needed || f.depth_upgrade_needed || null, needD = null;
      if (need && (dep === null || +need > dep + 0.001)) {
        needD = depthOpt.filter(function (x) { return x.depth && +x.depth >= +need - 0.001; }).sort(function (a, b) { return a.depth - b.depth; })[0] || { none: true };
      }
      return { id: f.handle, i: i, gap: gap, needD: needD, ok: !c || (i.cfm || 0) >= c.min, close: gap === null || gap <= 1 };
    }).filter(Boolean);
  }
  function insertCard(x, rec, c) {
    var i = x.i, bits = [];
    if (i.w) bits.push((i.wt || frac(i.w)) + '" wide' + (i.d ? ' x ' + (i.dt || frac(i.d)) + '" deep' : ''));
    if (i.cfm) bits.push('up to ' + i.cfm + ' CFM');
    if (i.duct) bits.push(i.duct + '"' + (i.shape ? ' ' + String(i.shape).toLowerCase() : '') + ' duct');
    if (x.gap !== null && x.gap > 0) bits.push('leaves ' + frac(x.gap) + '" each side');
    if (x.needD && x.needD.none) bits.push('<b>deeper than any inside depth option; call us</b>');
    else if (x.needD) bits.push('<b>needs the ' + esc(depthName(x.needD)) + ' inside depth option</b>' + (S.opt.depth === String(x.needD.v) ? ' (selected)' : ' <button type="button" class="res-btn" data-depth="' + esc(x.needD.v) + '">Add it</button>'));
    if (c && !x.ok) bits.push('below the ' + c.min + ' CFM we recommend for your cooktop');
    return '<li class="ins-card' + (rec ? ' is-rec' : '') + '"><div>' + (rec ? '<span class="ins-badge">Recommended for you</span>' : '') + '<h3><a href="' + esc(i.url) + '">' + esc(i.title) + '</a></h3></div>' +
      '<p class="ins-p">' + (i.compare > i.price ? '<s>' + money(i.compare) + '</s>' : '') + '<b>' + money(i.price) + '</b></p><p class="ins-spec">' + bits.join(' · ') + '</p></li>';
  }
  function inserts() {
    var cards = $('kcs-ins-cards'), forEl = $('kcs-ins-for'); if (!WOOD || !cards) return;
    var so = sizeObj(), v = curWood, open = openingFor(v), dep = interiorDepth(), c = cfmNeed();
    var call = D.phone ? ' Call us at <a href="tel:' + esc(D.phoneTel) + '">' + esc(D.phone) + '</a>' : ' Call us';
    if (forEl) forEl.innerHTML = so.w ? 'For your <b>' + so.w + '" hood</b>' + (open ? ': opening ' + frac(open) + '" wide' + (dep ? ' x ' + frac(dep) + '" deep' : '') : '') + '.' + (c ? ' You need at least <b>' + c.min + ' CFM</b>.' : (D.mode === 'wood' && $('kcs-finder') ? ' Use the Hood Finder above to sort these by the airflow you need.' : '')) : '';
    if (WD.trimless) { cards.innerHTML = '<li class="ins-empty">We haven\'t confirmed an insert for this style yet.' + call + ' and we\'ll check your insert before you order.</li>'; return; }
    var list = fitList();
    if (!list.length) { cards.innerHTML = '<li class="ins-empty">We haven\'t listed a checked insert for this size yet.' + call + ' and we\'ll help you choose one.</li>'; return; }
    var close = list.filter(function (x) { return x.close; }), narrow = list.filter(function (x) { return !x.close; });
    var recI = -1; close.some(function (x, k) { if (x.ok) { recI = k; return true; } });
    var h = close.map(function (x, k) { return insertCard(x, k === recI, c); }).join('');
    if (!close.length) h += '<li class="ins-empty">No insert we\'ve checked fills a ' + so.w + '" opening edge to edge. The ones below fit with a gap on each side.' + call + ' and we\'ll help you choose.</li>';
    if (narrow.length) h += (close.length ? '<li><details class="pm"><summary>Narrower inserts that also fit (' + narrow.length + ')</summary><ul class="ins-cards" style="padding:0 14px 14px">' : '') + narrow.map(function (x) { return insertCard(x, false, c); }).join('') + (close.length ? '</ul></details></li>' : '');
    cards.innerHTML = h;
    qa('[data-depth]', cards).forEach(function (b) { b.addEventListener('click', function () { S.opt.depth = b.dataset.depth; update(false); }); });
  }

  /* ---------- Hood Finder (rules: kcs_hood-finder-core.js) ---------- */
  var ventName = /victory/i.test(HD.brand || '') ? 'Victory' : (HD.brand || 'the maker');
  var isInsert = /insert/i.test(HD.mount || '');
  function hoodWord(c) {
    if (!c || WOOD || isInsert) return c;
    return [c[0], c[1], String(c[2]).replace(/this insert/g, 'this hood').replace(/Victory inserts need/g, 'This hood needs')];
  }
  function heightPlan() {
    var ceil = (+($('kcs-f-cft') || {}).value || 8) * 12 + (+($('kcs-f-cin') || {}).value || 0);
    var top = num('kcs-f-ctop') || 36, gap = num('kcs-f-gap');
    if (gap === null) gap = WD.gaps && WD.gaps.length ? +WD.gaps[0] : null;
    if (gap === null) return null;
    var Hn = Math.round((ceil - top - gap) * 100) / 100, so = sizeObj();
    var ext = (OPTS.filter(function (o) { return o.key === 'ext'; })[0] || { choices: [] }).choices.filter(function (c) { return c.ext; });
    var cut = (OPTS.filter(function (o) { return o.key === 'cut'; })[0] || { choices: [] }).choices.filter(function (c) { return c.cut; });
    var c = [];
    heightsList().forEach(function (h) {
      if (!sizeFor(so.w, h)) return;
      var d = h - Hn;
      if (d >= 0 && d < 1) c.push({ h: h, cost: 0, txt: h + '" tall, as is' });
      else if (d >= 1) { var r = Math.ceil(d - 0.001), k = cut.filter(function (x) { return +x.cut === r; })[0]; if (k) { var p = addonPrice(k).now; c.push({ h: h, cut: k, cost: p, txt: h + '" tall, cut down ' + r + '"' + (p ? ' (+' + money(p) + ')' : '') }); } }
      else { var e = ext.filter(function (x) { return h + +x.ext >= Hn && h + +x.ext - Hn < 1; })[0]; if (e) { var pe = addonPrice(e).now; c.push({ h: h, ext: e, cost: pe, txt: h + '" tall with a ' + e.ext + '" chimney extension' + (pe ? ' (+' + money(pe) + ')' : '') }); } }
    });
    c.sort(function (a, b) { return a.cost - b.cost; });
    var hs = heightsList(), maxExt = ext.reduce(function (m, x) { return Math.max(m, +x.ext); }, 0), maxCut = cut.reduce(function (m, x) { return Math.max(m, +x.cut); }, 0);
    return { H: Hn, ceil: ceil, gap: gap, best: c[0], all: c, max: hs.length ? hs[hs.length - 1] + maxExt : null, min: hs.length ? hs[0] - maxCut : null };
  }
  function finder() {
    var out = $('kcs-finder-res'), listEl = $('kcs-finder-list');
    if (!out || typeof HF === 'undefined') return;
    var cook = num('kcs-f-cook'), island = FD.where === 'island', res = [], checks = [];
    var so = WOOD ? sizeObj() : {};
    var hoodW = WOOD ? so.w : (HD.nominal ? +HD.nominal : (HD.width ? +HD.width : null));
    var smallest = WOOD ? widthsList()[0] : hoodW;
    var w = HF.width(cook, island, smallest);
    if (w) {
      var cmp = '';
      if (hoodW && !isInsert) cmp = hoodW < w.min ? '<p>This hood is <b>' + frac(hoodW) + '"</b> wide, narrower than your cooktop calls for, so some smoke from the outer burners may escape. We recommend ' + w.min + '" or wider. You can still choose it.</p>' : '<p>This ' + frac(hoodW) + '" hood is ' + (hoodW >= w.rec ? 'a great fit.' : 'wide enough.') + '</p>';
      var useW = WOOD && hoodW !== w.rec && sizeFor(w.rec, so.h) ? '<button type="button" class="res-btn" data-setw="' + w.rec + '">Use ' + w.rec + '" wide</button>' : '';
      res.push('<div class="res-block"><h3>Hood width</h3><p class="res-big">' + (w.min === w.rec ? w.rec + '"' : w.min + '" minimum, ' + w.rec + '" better') + '</p><p>' + w.text + '</p>' + cmp + useW + '</div>');
    } else res.push('<div class="res-block"><h3>Hood width</h3><p>Pick your cooktop width to see the size we recommend.</p></div>');
    var c = cfmNeed(), hoodCfm = null;
    if (!WOOD) {
      hoodCfm = HD.cfm ? +HD.cfm : null;
      var dsv = ($('kcs-f-dsize') || {}).value;
      if (HD.cfmByDuct && dsv && HD.cfmByDuct[dsv]) hoodCfm = +HD.cfmByDuct[dsv];
    }
    if (c) {
      var cmpC = hoodCfm ? (hoodCfm >= c.min ? '<p>This hood moves up to <b>' + hoodCfm + ' CFM</b>, which meets that.</p>' : '<p>This hood moves up to <b>' + hoodCfm + ' CFM</b>, below the ' + c.min + ' CFM we recommend for your cooktop. It will still work, it just clears less smoke. ' + HF.LOCAL + '</p>') : '';
      res.push('<div class="res-block"><h3>Airflow</h3><p class="res-big">' + c.min + ' to ' + c.target + ' CFM</p><p>' + c.text + '</p>' + cmpC + '<ul class="tips">' + c.tips.map(function (t) { return '<li>' + t + '</li>'; }).join('') + '</ul></div>');
    }
    var rec = null;
    if (WOOD) {
      var fl = WD.trimless ? [] : fitList(), close = fl.filter(function (x) { return x.close; });
      rec = close.filter(function (x) { return x.ok; })[0] || close[0] || fl[0] || null;
      if (rec) res.push('<div class="res-block"><h3>Insert</h3><p><a href="' + esc(rec.i.url) + '"><b>' + esc(rec.i.title) + '</b></a>' + (rec.i.cfm ? ': ' + rec.i.cfm + ' CFM' : '') + '. ' + (rec.i.compare > rec.i.price ? '<s>' + money(rec.i.compare) + '</s> ' : '') + '<b>' + money(rec.i.price) + '</b></p>' +
        (rec.needD && !rec.needD.none && S.opt.depth !== String(rec.needD.v) ? '<p>It needs the <b>' + esc(depthName(rec.needD)) + '</b> inside depth option on the hood.</p><button type="button" class="res-btn" data-depth="' + esc(rec.needD.v) + '">Add the deeper inside</button>' : '') + '</div>');
      else if (WD.trimless) res.push('<div class="res-block"><h3>Insert</h3><p>Call us and we\'ll confirm an insert for this style before you order.</p></div>');
      var hp = heightPlan();
      if (hp) {
        if (hp.max && hp.H > hp.max) checks.push(['bad', 'Ceiling too tall for this hood', 'From the bottom of the hood to your ' + Math.floor(hp.ceil / 12) + ' ft ' + (hp.ceil % 12) + ' in ceiling is ' + hp.H + '". The tallest we can make this hood is ' + hp.max + '". Call us and we\'ll look at a custom option.']);
        else if (hp.min && hp.H < hp.min) checks.push(['warn', 'Very little room above the cooktop', 'That leaves ' + hp.H + '" for the hood. The shortest we can make it is ' + hp.min + '". Try a smaller gap above the cooktop, or call us. ' + HF.LOCAL]);
        else if (hp.best) res.push('<div class="res-block"><h3>Hood height</h3><p class="res-big">' + hp.best.txt.split(',')[0].replace(' with', ' +') + '</p><p>Your hood needs about <b>' + hp.H + '"</b> from its bottom to the ceiling. We suggest: ' + hp.best.txt + '.' + (hp.all.length > 1 ? ' Also works: ' + hp.all.slice(1).map(function (x) { return x.txt; }).join('; ') + '.' : '') + '</p><button type="button" class="res-btn" id="kcs-use-h">Use this height</button></div>');
        else checks.push(['warn', 'Hood height', 'We couldn\'t match ' + hp.H + '" exactly with our heights and options. Call us and we\'ll work it out.']);
        var gl = WD.gaps && WD.gaps.length ? [Math.min.apply(null, WD.gaps), Math.max.apply(null, WD.gaps)] : null;
        if (gl && (hp.gap < gl[0] || hp.gap > gl[1])) checks.push(['warn', 'Height above the cooktop', hp.gap + '" is outside the ' + gl[0] + '" to ' + gl[1] + '" we recommend for this wood hood. ' + HF.LOCAL]);
        if (rec) {
          if (rec.i.hlo || rec.i.hhi) checks.push(HF.height(hp.gap, rec.i.hlo, rec.i.hhi, 'Victory'));
          else checks.push(['info', 'Height for the insert', 'Check the ' + esc(rec.i.model) + ' manual for its height above the cooktop.']);
        }
      }
    } else {
      var gap = num('kcs-f-gap');
      if (gap) {
        if (HD.hlo || HD.hhi) checks.push(HF.height(gap, HD.hlo, HD.hhi, ventName));
        else if (HD.hrec) checks.push(gap <= HD.hrec ? ['ok', 'Height: ' + gap + '" above the cooktop', 'Within the ' + HD.hrec + '" ' + ventName + ' recommends.'] : ['warn', 'Height: ' + gap + '" above the cooktop', 'More than the ' + HD.hrec + '" ' + ventName + ' recommends. It will still work, but it catches less smoke. ' + HF.LOCAL]);
      }
    }
    // venting, duct size and run
    var needDuct = WOOD ? (rec && rec.i.duct) : HD.duct, runMax = WOOD ? (rec && rec.i.run) : HD.run;
    if (FD.vent === 'no') {
      if (WOOD) checks.push(['warn', 'Venting', 'Inserts are built to vent outside. Ask us about a recirculating kit for your insert before you order. It filters grease and odors but doesn\'t remove heat, steam or smoke the way venting outside does. ' + HF.LOCAL]);
      else if (HD.ductless) checks.push(['warn', 'Venting: no outside duct', esc(HD.ductless)]);
      else checks.push(['warn', 'Venting', 'This hood is made to vent outside. Call us and we\'ll help you find one that recirculates. ' + HF.LOCAL]);
    }
    if (FD.vent === 'unsure') checks.push(['info', 'Venting', 'Check with your installer whether you can vent outside.']);
    if (FD.vent === 'have' || FD.vent === 'add') {
      if (FD.vent === 'have' && needDuct) { var dv = ($('kcs-f-dsize') || {}).value; checks.push(hoodWord(HF.ductSize(dv === 'rect' ? 'rect' : (+dv || null), +needDuct))); }
      var ft = num('kcs-f-ft');
      if (ft !== null && runMax) HF.ductRun(ft, +(($('kcs-f-90') || {}).value) || 0, +(($('kcs-f-45') || {}).value) || 0, +(($('kcs-f-tr') || {}).value) || 0, +runMax).forEach(function (x) { checks.push(hoodWord(x)); });
    }
    var mcfm = WOOD ? (rec && rec.i.cfm) : HD.cfm;
    if (mcfm) checks.push(HF.makeup(+mcfm));
    if (WOOD) { if (rec) checks.push(HF.power()); }
    else if (HD.electrical) {
      if (FD.pwr === 'yes') checks.push(['ok', 'Power', esc(HD.electrical)]);
      else if (FD.pwr === 'plan') checks.push(['ok', 'Power', 'Tell your electrician: ' + esc(HD.electrical)]);
      else if (FD.pwr === 'unsure') checks.push(['warn', 'Power', esc(HD.electrical) + ' An electrician can tell you if you have one.']);
    }
    if (!WOOD && Array.isArray(HD.fitNotes)) HD.fitNotes.forEach(function (n) { if (n && n.title) checks.push(['info', esc(n.title), esc(n.text)]); });
    out.innerHTML = res.join('');
    listEl.innerHTML = checks.filter(Boolean).map(HF.li).join('');
    qa('[data-setw]', out).forEach(function (b) { b.addEventListener('click', function () { setSize(+b.dataset.setw, sizeObj().h); }); });
    qa('[data-depth]', out).forEach(function (b) { b.addEventListener('click', function () { S.opt.depth = b.dataset.depth; update(false); }); });
    var uh = $('kcs-use-h');
    if (uh) uh.addEventListener('click', function () {
      var b = heightPlan().best; if (!b) return;
      var s = sizeFor(so.w, b.h); if (s) S.size = s.v;
      if (S.opt.cut !== undefined) S.opt.cut = b.cut ? String(b.cut.v) : String(OPTS.filter(function (o) { return o.key === 'cut'; })[0].choices[0].v);
      if (S.opt.ext !== undefined) S.opt.ext = b.ext ? String(b.ext.v) : String(OPTS.filter(function (o) { return o.key === 'ext'; })[0].choices[0].v);
      update(false); $('kcs-q-buy').scrollIntoView({ behavior: 'smooth' });
    });
  }
  var ff = $('kcs-finderform');
  if (ff) {
    var gapIn = $('kcs-f-gap'), gh = $('kcs-f-gaphelp');
    if (WOOD && WD.gaps && WD.gaps.length) { gapIn.value = WD.gaps[0]; if (gh) gh.textContent = 'We recommend ' + Math.min.apply(null, WD.gaps) + '" to ' + Math.max.apply(null, WD.gaps) + '" between the cooktop and the bottom of a wood hood. 36" is a typical counter height.'; }
    else if (!WOOD && (HD.hrec || HD.hlo)) { gapIn.placeholder = 'e.g. ' + (HD.hrec || HD.hlo); if (gh) gh.textContent = ventName + (HD.hlo && HD.hhi ? ' recommends ' + HD.hlo + '" to ' + HD.hhi + '"' : ' recommends about ' + (HD.hrec || HD.hlo) + '"') + ' between the cooktop and the bottom of this hood. 36" is a typical counter height.'; }
    qa('.q-opt', ff).forEach(function (b) { b.addEventListener('click', function () {
      var k = b.dataset.k; FD[k] = b.dataset.val;
      qa('.q-opt[data-k="' + k + '"]', ff).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (k === 'vent') { $('kcs-f-ductbox').hidden = !(FD.vent === 'have' || FD.vent === 'add'); $('kcs-f-dsize-l').hidden = FD.vent !== 'have'; }
      inserts(); finder();
    }); });
    qa('input, select', ff).forEach(function (i) { i.addEventListener('input', function () { inserts(); finder(); }); });
  }

  /* ---------- Add to cart (wood): hood + add-ons in one /cart/add.js call ---------- */
  if (WOOD && form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = curWood; if (!v || atc.disabled) return;
      var pc = choice('paint');
      if (pc && pc.needs_code && !S.code) { msg.hidden = false; msg.textContent = 'Please enter your paint color code.'; var ci = $('kcs-pm-code'); if (ci) ci.focus(); return; }
      var group = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      var forTxt = D.title + ' / ' + v.title + (v.sku ? ' (' + v.sku + ')' : '');
      var hp = { _kcs_group: group };
      OPTS.forEach(function (o) {
        var c = choice(o.key); if (!c || aid(c)) return;
        var anyPriced = o.choices.some(function (x) { return aid(x); });
        if (!anyPriced || o.choices[0] !== c) hp[o.label] = c.label;   // free choices ride on the hood line
      });
      if (aid(pc) && S.code) hp['Paint code'] = S.code;
      var items = [{ id: v.id, quantity: 1, properties: hp }];
      OPTS.forEach(function (o) {
        var c = choice(o.key); if (!aid(c)) return;
        var p = { _For: forTxt, _kcs_group: group };
        if (o.key === 'paint' && S.code) p['Paint code'] = S.code;
        items.push({ id: aid(c), quantity: 1, properties: p });
      });
      atc.disabled = true; atc.textContent = 'Adding…'; msg.hidden = true;
      fetch((D.cartAddUrl || '/cart/add') + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error(r.j && (r.j.description || r.j.message) || 'Could not add to cart');
          window.location.href = D.cartUrl || '/cart';
        })
        .catch(function (err) {
          atc.disabled = false; atc.textContent = 'Add to cart'; msg.hidden = false;
          msg.textContent = 'We couldn\'t add this to your cart (' + err.message + '). Please try again or call us' + (D.phone ? ' at ' + D.phone : '') + '.';
        });
    });
  }

  if (WOOD) update(false); else finder();

  /* ---------- highlight the nav link for the section on screen (the nav itself is not sticky) ---------- */
  var links = qa('.jump a');
  if ('IntersectionObserver' in window && links.length) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) links.forEach(function (a) { a.setAttribute('aria-current', a.getAttribute('href') === '#' + e.target.id ? 'true' : 'false'); }); }); }, { rootMargin: '-40% 0px -55% 0px' });
    qa('section.band[id]').forEach(function (s) { io.observe(s); });
  }
})();
/* 🛑 KCS HOOD PDP SCRIPT */
